// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DDk6coGkjQjQYj {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-200, 16px);
}
.DDk6coGkjQjQYj a,
.DDk6coGkjQjQYj button {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex: 0 0 calc(25% - 8px);
  flex-direction: column;
  justify-content: center;
  min-width: 120px;
  height: 80px;
  margin: var(--ds-space-050, 4px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-neutral, #091e420f);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  line-height: 16px;
  text-align: center;
}
.DDk6coGkjQjQYj a:hover,
.DDk6coGkjQjQYj button:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.DDk6coGkjQjQYj > div {
  height: auto;
}
.DDk6coGkjQjQYj > div button {
  height: auto;
}
.DDk6coGkjQjQYj p {
  flex: none;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var jiraProjects = `DDk6coGkjQjQYj`;
export default ___CSS_LOADER_EXPORT___;
